import config from '@/js/bootstrap/config'
import logger from '@/js/bootstrap/logger'
import http from '@/js/bootstrap/http'
import plugins from '@/js/bootstrap/plugins'
import router from '@/js/bootstrap/router'
import components from '@/js/bootstrap/components'
import directives from '@/js/bootstrap/directives'
import i18n from '@/js/bootstrap/i18n'
import filters from '@/js/bootstrap/filters'
import mixins from '@/js/bootstrap/mixins'
import apollo from '@/js/bootstrap/apollo'
import store from '@/js/bootstrap/store'
import services from '@/js/bootstrap/services'

export default function bootstrap(app){

    config();
    logger(app);
    http();
    router(app);
    components(app);
    directives(app);
    i18n(app);
    plugins(app);
    filters(app);
    mixins(app);
    apollo(app);
    store(app);
    services(app);
}